import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, permission, requireAdmin = false }) => {
  const { isAuthenticated, hasPermission, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check admin requirement
  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/enquiries" replace />;
  }

  // Check specific permission
  if (permission && !hasPermission(permission) && !isAdmin()) {
    return <Navigate to="/enquiries" replace />;
  }

  return children;
};

export default ProtectedRoute;

